import { Button, Card } from 'nhsuk-react-components';
import { useNavigate, useParams } from 'react-router-dom';

import React from 'react';
import { setTitle } from '@util/browser';

export const clickHandlers = {
    backHome: handler => {
        handler();
    }
};

const ViewConfirmDeletions = props => {
    const params = useParams();
    const history = useNavigate();
    setTitle(`Record Deleted - ${props.collection.name}`);

    return (
        <div className="nhsuk-grid-row">
            <div className="nhsuk-grid-column-full">
                <Card feature>
                    <Card.Content>
                        <Card.Heading>Record Deleted</Card.Heading>
                        <Card.Description>This record has been deleted.</Card.Description>
                    </Card.Content>
                </Card>

                <span className="nhsuk-u-margin-top-3">
                    <Button
                        className="nhsuk-button nhsuk-button--primary nhsuk-u-margin-top-3"
                        aria-disabled="false"
                        type="submit"
                        onClick={() => {
                            const path = `/${params.collection}`;
                            history(path);
                            clickHandlers.backHome(props.backHomeHandler);
                        }}
                    >
                        Back to Home
                    </Button>
                </span>
            </div>
        </div>
    );
};

export default ViewConfirmDeletions;
